export default __webpack_public_path__ + "static/media/404-bg.ea45746c.png";